<div
  class="dot {{ color() }}"
  [class.animate]="pulse()"
  [style.width.px]="size()"
  [style.height.px]="size()"
>
  <ng-content></ng-content>
</div>
